import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const authClient = axios.create({ baseURL: API, withCredentials: true });

const CustomerAuthContext = createContext(null);

export function CustomerAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try { const { data } = await authClient.get("/auth/customer/me"); setUser(data); return data; }
    catch { setUser(null); return null; }
    finally { setLoading(false); }
  }, []);

  useEffect(() => {
    // Returning from Google: AuthCallback exchanges the session_id first, so skip the /me check here.
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    refresh();
  }, [refresh]);

  const login = (returnPath = "/account") => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + returnPath;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try { await authClient.post("/auth/customer/logout"); } catch {}
    setUser(null);
  };

  return <CustomerAuthContext.Provider value={{ user, loading, login, logout, refresh, setUser }}>{children}</CustomerAuthContext.Provider>;
}

export const useCustomerAuth = () => useContext(CustomerAuthContext);
